import React, { Component } from 'react';
import { reportClientError } from '../../../services/clientErrorService';
import MapUnavailable from './MapUnavailable';

/**
 * Boundary acotado al contenedor del mapa: si algo del árbol del mapa tira en
 * render, cae solo ese recuadro (no la página: header, login y paneles siguen).
 *
 * - Es un bug real de render → se reporta como `error_boundary` con
 *   `metadata.boundary = 'map'`. La falta de WebGL **no** pasa por acá: se detecta
 *   antes de crear el mapa y va como `window_error` (ver `webglSupport.js`).
 * - Solo atrapa render/ciclo de vida; handlers y efectos async se cubren con
 *   guards (`if (!map)`, `canAccessMapStyle`).
 */
export default class MapErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    void reportClientError({
      error,
      errorInfo,
      source: 'error_boundary',
      metadata: { boundary: 'map', surface: this.props.surface || null },
    });
  }

  render() {
    if (this.state.hasError) {
      const { fallback, variant = 'stage' } = this.props;
      if (fallback !== undefined) return fallback;
      return <MapUnavailable variant={variant} reason="map_crash" />;
    }
    return this.props.children;
  }
}
